import { connect } from 'react-redux'
import { setSearchResultsLoaded } from 'redux/actions'
import MultiPageSearchResults from 'pages/search/MultiPageSearchResults'

const mapDispatchToProps = dispatch => ({
  setSearchResultsLoaded: isLoaded => dispatch(setSearchResultsLoaded(isLoaded))
})

export default connect(null, mapDispatchToProps)(MultiPageSearchResults)
